<template>
  <div>
    <MyHeader
      v-bind:nav_items="nav_items"
      v-bind:init_index="activeIndex"
      v-on:site-index="onSiteIndexEvent"
    >
      <template v-if="activeIndex===1">
        <kastenmodell-view />
      </template>
      <template v-if="activeIndex===2">
        <eine-spalte-view />
      </template>
      <template v-else-if="activeIndex===3">
        <zwei-spalten-view />
      </template>
      <template v-else-if="activeIndex===4">
        <hallo-view />
      </template>
      <template v-else-if="activeIndex===5">
        <flexible-view />
      </template>
      <template v-else-if="activeIndex===6">
        <about-view/>
      </template>
    </MyHeader>
  </div>
</template>

<script>
import MyHeader from "./global/global-layout.vue";
import EineSpalteView from "./examples/eine-spalte.vue";
import ZweiSpaltenView from "./examples/zwei-spalten.vue";
import HalloView from "./examples/HelloWorld.vue";
import FlexibleView from "./examples/flexible-design/flexible-design.vue";
import KastenmodellView from './examples/kastenmodell.vue';
import AboutView from "./eisart/datenschutz.vue";

export default {
  name: "MainView",
  data() {
    return {
      activeIndex: 2,
      nav_items: [
        { idx: 1, message: "Kastenmodell" },
        { idx: 2, message: "Eine Spalte" },
        { idx: 3, message: "Zwei Spalten" },
        { idx: 4, message: "Hallo Welt" },
        { idx: 5, message: "Flexibel Layout" },
        { idx: 6, message: "About" }
      ]
    };
  },
  components: {
    MyHeader,
    EineSpalteView,
    ZweiSpaltenView,
    HalloView,
    FlexibleView,
    KastenmodellView,
    AboutView
  },

  methods: {
    onSiteIndexEvent: function(index) {
      this.activeIndex = index;
    }
  }
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/main.vue